import {
  USER_START,
  USER_DATA,
  USER_END,
  USER_EDIT,
  USER_CREATE,
  USER_UPDATE,
  USER_DELETE,
} from "../../slices/type";

interface InitState {
  data: any[];
  getByID: any[];
  update: any[];
  create: any[];
  dataSingle: any[];
  loading: boolean;
}

const initState: InitState = {
  data: [],
  dataSingle: [],
  create: [],
  update: [],
  getByID: [],
  loading: false,
};

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

const User_Red = (state = initState, action: Action): InitState => {
  switch (action.type) {
    case USER_START:
      return {
        ...state,
        loading: action.loading ?? false,
      };
    case USER_DATA:
      return {
        ...state,
        data: action.payload ?? [],
        loading: action.loading ?? false,
      };
    case USER_CREATE:
      return {
        ...state,
        create: action.payload ?? [],
        loading: action.loading ?? false,
      };
    case USER_UPDATE:
      return {
        ...state,
        update: action.payload ?? [],
        loading: action.loading ?? false,
      };
    case USER_EDIT:
      return {
        ...state,
        getByID: action.payload ?? [],
        loading: action.loading ?? false,
      };
    case USER_DELETE:
      return {
        ...state,
        loading: false,
      };
    case USER_END:
      return {
        ...state,
        dataSingle: action.payload ?? [],
        loading: action.loading ?? false,
      };
    default:
      return state;
  }
};

export default User_Red;
